import FormNewUser, { FormNewUserData } from 'dashboard/forms/FormNewUser';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Role } from 'dashboard/models/role';

interface AddUserModalProps {
  handleClose: () => void;
  handleSubmitAddUser: (values: FormNewUserData) => Promise<void>;
  roles: Role[];
}

export default ({ handleClose, handleSubmitAddUser, roles }: AddUserModalProps) => (
  <ModalContainer data-test='add-user-modal'>
    <ModalHeader data-test='add-user-modal__header' onClose={handleClose}>
      Invite new user
    </ModalHeader>

    <ModalBody>
      <FormNewUser onSubmit={handleSubmitAddUser} roles={roles} />
    </ModalBody>
  </ModalContainer>
);
